import React, { useEffect, useContext } from "react";
import * as APICalls from "./JsFiles/APICalls";
import { decodedTokenObjectContext, workItemObjectContext } from "./App";

import "../style/lawChanges.css";

export default function LawChanges() {
  const [workItemObject, setWorkItemObject] = useContext(workItemObjectContext);
  const [decodedTokenObject, setDecodedTokenObject] = useContext(decodedTokenObjectContext);

  useEffect(() => {
    try {
      APICalls.getChangesSummaries(workItemObject.Id, decodedTokenObject)
        .then((res) => {
          showResult(res);
        })
        .catch((err) => {
          console.log("Error on getChangesSummaries api", err);
          sendLog("ERROR", "Error on getChangesSummaries api");
        });
    } catch (err) {
      console.log("problem with getChangesSummaries", err);
      sendLog("ERROR", "Error showing ChangesSummaries ");
    }
  }, []);

  const showResult = (res) => {
    const changes = res.ParagraphSummaries;
    let resultDiv = document.querySelector(".changesResult");
    resultDiv.innerHTML = "";
    changes.forEach((element) => {
      if (element.ChangeHtml) {
        var containerElement = document.createElement("div");
        containerElement.className = "changesTabContent";
        containerElement.id = element.SubId;
        containerElement.innerHTML = element.ChangeHtml;
        let container = ConvertXMLtoHTML(containerElement);
        resultDiv.innerHTML += container.outerHTML;
      }
    });
  };

  return <div className="changesResult"></div>;
}

export function ConvertXMLtoHTML(containerElement) {
  let delElements = containerElement.querySelectorAll("del");
  for (const delElement of delElements) {
    const spanElement = document.createElement("span");
    spanElement.innerHTML = delElement.innerHTML;
    spanElement.classList.add("del", delElement.getAttribute("class"));
    delElement.parentNode.replaceChild(spanElement, delElement);
  }
  let insElements = containerElement.querySelectorAll("ins");
  for (const insElement of insElements) {
    const spanElement = document.createElement("span");
    spanElement.innerHTML = insElement.innerHTML;
    spanElement.classList.add("ins", insElement.getAttribute("class"));
    insElement.parentNode.replaceChild(spanElement, insElement);
  }

  return containerElement;
}
